import wallet from '../../../../assets/lotties/wallet.json';
import post from '../../../../assets/lotties/posts.json';
import tip from '../../../../assets/lotties/ethers.json';



export const featuresSectionData=[
    {
        id:1,
        title:"Connect Your Wallet",
        description:"Connect your wallet to the ethereum blockchain to post and tip other images.",
        lottie:wallet
    },
    {
        id:2,
        title:"Post Your Images",
        description:"Post your images on the site to gain popularity.",
        lottie:post
    },
    {
        id:3,
        title:"Tip and get tipped",
        description:"You can tip images if you find them intresting.",
        lottie:tip
    }
]